export enum VinImageIds {
  VIN_FRONT = 'vin-front',
  VIN_SIDE = 'vin-side',
  VIN_ETCHING_FRONT = 'vin-etching-front',
  VIN_ETCHING_SIDE = 'vin-etching-side',
}
